const FATAL_ERROR_DISPLAYED = "FATAL_ERROR_DISPLAYED";
export const displayFatalError = (message: string): IAction<string> => ({
  type: FATAL_ERROR_DISPLAYED,
  payload: message,
});

export type IFatalErrorState = string | null;

const fatalErrorReducer = (
  state: IFatalErrorState = null,
  action: IAction<any>,
) => {
  switch (action.type) {
    case FATAL_ERROR_DISPLAYED:
      return action.payload;
    default:
      return state;
  }
};

export default fatalErrorReducer;
